import { localStorage } from '@lib/storages/localStorage';
import { get } from 'lodash';
import { darken, lighten } from 'polished';
import { css } from 'styled-components';

export const THEMES = {
    default: {
        background: '#fff',
        color: '#222',
        borderColor: '#ccc',
        zIndex: 1210,
        size: {
            desktop: 70,
            mobile: 48,
        },

        breakpoint: '@media screen and (max-width: 767px)',
    },

    dark: {
        background: '#060606',
        color: '#fff',
        borderColor: '#2e2e2e',
    },

    light: {
        background: '#fff',
        color: '#222',
        borderColor: '#ccc',
    },
};

type ThemeKeys = keyof typeof THEMES;
export type HeaderThemeType = typeof THEMES.default;

export const PAGE_HEADER_THEME = {
    getTheme(): HeaderThemeType {
        return PAGE_HEADER_THEME.getThemeByName(PAGE_HEADER_THEME.getThemeName());
    },
    getThemeByName(theme: ThemeKeys): HeaderThemeType {
        const defaultTheme = THEMES.default;
        const themeObject = THEMES[theme] || {};

        return {
            ...defaultTheme,
            ...themeObject,
        } as any;
    },
    setTheme(theme: ThemeKeys) {
        localStorage.setItem('selected_theme', theme);
        window.location.reload();
    },

    getBorderCss(position = 'bottom') {
        const borderColor = PAGE_HEADER_THEME.get('borderColor');
        return borderColor ? css`border-${position}: 1px solid ${borderColor};` : '';
    },

    getBackground(number = 0) {
        const { background } = PAGE_HEADER_THEME.getTheme();

        if (number > 0) {
            let fn = lighten;
            if (background === '#fff') {
                fn = darken;
            }

            return fn(number, background);
        }

        return background;
    },
    get(prop: keyof HeaderThemeType | string) {
        return get(PAGE_HEADER_THEME.getTheme(), prop);
    },
    getThemeName() {
        return localStorage.getItem('selected_theme');
    },
    getThemes(): { [name: string]: HeaderThemeType } {
        return Object.keys(THEMES).reduce(
            (acc, name) => ({
                ...acc,
                [name as any]: PAGE_HEADER_THEME.getThemeByName(name as any),
            }),
            {},
        );
    },
    getThemesAsEntry() {
        return Object.entries(PAGE_HEADER_THEME.getThemes());
    },
};
